"use client"
/* */
const isNullish = (children) => children === null || children === void 0 || children === false;
const areChildrenEmpty = (children) => {
  if (isNullish(children)) {
    return true;
  }
  if (Array.isArray(children)) {
    return children.length === 0 || children.every(isNullish);
  }
  return false;
};

export { areChildrenEmpty };
//# sourceMappingURL=areChildrenEmpty.mjs.map
